import * as React from "react";

function SvgRoundFat(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}><path d="M22.3 30.5c0 6-4.8 10.8-10.8 10.8-2.3 0-4.5-.8-6.3-2-.9-.6-1.8-1.4-2.5-2.4-1.8-2.4-2.7-5.4-2.7-9 0-4.5 1.3-8.5 4-11.9 2.7-3.4 6.4-5.8 11.1-7.3v2.8c-2.7 2.2-4.4 5-4.9 8.3.4-.1.9-.1 1.3-.1 6-.1 10.8 4.8 10.8 10.8zm16.9-10.9c-.5 0-.9 0-1.3.1.5-3.3 2.2-6.1 4.9-8.3V8.7c-4.7 1.4-8.4 3.9-11.1 7.3-2.7 3.4-4 7.4-4 11.9 0 3.6.9 6.6 2.7 9 .8 1 1.6 1.8 2.5 2.4 1.8 1.3 3.9 2 6.3 2 6 0 10.8-4.8 10.8-10.8 0-6-4.8-10.9-10.8-10.9z" /></svg>;
}

export default SvgRoundFat;